window.RCQ_SKIN_TEST = {
  "questions": [
    {
      "id": "esseExperience",
      "kicker": "Kennismaking",
      "title": "Hoeveel ervaring heb je met ESSE?",
      "help": "Denk aan producten van ESSE.",
      "type": "radio",
      "answers": [
        {
          "value": "new",
          "label": "Nog niet."
        },
        {
          "value": "some",
          "label": "Een paar keer."
        },
        {
          "value": "regular",
          "label": "Ik gebruik ESSE al langer."
        }
      ]
    },
    {
      "id": "skinType",
      "kicker": "Huidtype",
      "title": "Hoe zou je je huid meestal omschrijven?",
      "help": "Kies wat meestal bij je past.",
      "type": "radio",
      "answers": [
        {
          "value": "dry",
          "label": "Droog: mijn huid voelt vaak droog of trekkerig aan."
        },
        {
          "value": "normal",
          "label": "Normaal: mijn huid voelt meestal comfortabel aan."
        },
        {
          "value": "combination",
          "label": "Gecombineerd: sommige zones glimmen, andere voelen normaler of droger."
        },
        {
          "value": "oily",
          "label": "Vet: mijn huid glimt op veel plekken."
        },
        {
          "value": "unsure",
          "label": "Ik weet het niet goed."
        }
      ]
    },
    {
      "id": "sensitivity",
      "kicker": "Gevoeligheid",
      "title": "Hoe reageert je huid meestal op verzorgingsproducten?",
      "help": "Denk aan terugkerende roodheid, prikken of ongemak.",
      "type": "radio",
      "answers": [
        {
          "value": "often",
          "label": "Mijn huid reageert regelmatig of ik weet dat ze gevoelig is."
        },
        {
          "value": "sometimes",
          "label": "Soms reageert mijn huid, maar niet op alles."
        },
        {
          "value": "rarely",
          "label": "Mijn huid reageert meestal niet opvallend."
        },
        {
          "value": "unsure",
          "label": "Ik weet het niet zeker."
        }
      ]
    },
    {
      "id": "dryness",
      "kicker": "Droogtegevoel",
      "title": "Hoe vaak voelt je huid droog of trekkerig?",
      "help": "Dit staat los van je huidtype: ook een vettere huid kan droog of trekkerig aanvoelen.",
      "type": "radio",
      "answers": [
        {
          "value": "often",
          "label": "Vaak, ook als mijn huid op andere plekken glimt."
        },
        {
          "value": "sometimes",
          "label": "Af en toe, bijvoorbeeld bij kou of na het reinigen."
        },
        {
          "value": "rarely",
          "label": "Zelden of nooit."
        },
        {
          "value": "unsure",
          "label": "Ik kan dit niet goed inschatten."
        }
      ]
    },
    {
      "id": "concerns",
      "kicker": "Huidwensen",
      "title": "Waar wil je vooral aandacht aan geven?",
      "help": "Kies maximaal twee. Je krijgt ook advies als je niets kiest.",
      "type": "checkbox",
      "max": 2,
      "answers": [
        {
          "value": "dryness",
          "label": "Droogte of trekkerigheid"
        },
        {
          "value": "redness",
          "label": "Roodheid of gevoeligheid"
        },
        {
          "value": "oiliness",
          "label": "Glimmen of onzuiverheden"
        },
        {
          "value": "lines",
          "label": "Fijne lijntjes of rimpels"
        },
        {
          "value": "tone",
          "label": "Pigmentvlekjes of een ongelijkmatige teint"
        },
        {
          "value": "firmness",
          "label": "Stevigheid of elasticiteit"
        },
        {
          "value": "barrier",
          "label": "Mijn huid helpen vocht vast te houden"
        },
        {
          "value": "simple",
          "label": "Een eenvoudige routine die ik kan volhouden"
        }
      ]
    }
  ],
  "kits": {
    "sensitive": {
      "title": "Sensitive Skin Trial / Travel Set",
      "officialText": "Een kennismakingsset uit de Sensitive-lijn van ESSE."
    },
    "dry": {
      "title": "Dry Skin Trial / Travel Set",
      "officialText": "Een kennismakingsset van ESSE voor de droge huid."
    },
    "balanced": {
      "title": "Oily / Combination / Normal Skin Trial / Travel Set",
      "officialText": "Een kennismakingsset van ESSE voor de normale, gecombineerde of vettere huid."
    }
  },
  "concernLabels": {
    "dryness": "Droogte of trekkerigheid",
    "redness": "Roodheid of gevoeligheid",
    "oiliness": "Glimmen of onzuiverheden",
    "lines": "Fijne lijntjes of rimpels",
    "tone": "Pigmentvlekjes of een ongelijkmatige teint",
    "firmness": "Stevigheid of elasticiteit",
    "barrier": "Vocht vasthouden",
    "simple": "Een eenvoudige routine"
  },
  "concernAdvice": {
    "dryness": "Je wilt ook aandacht geven aan droogte of trekkerigheid. Een rustige opbouw helpt je te merken wat prettig voelt.",
    "redness": "Je noemt roodheid of gevoeligheid. Introduceer producten rustig, zodat je merkt hoe je huid erop reageert.",
    "oiliness": "Je wilt aandacht geven aan glimmen of onzuiverheden. Houd je verzorging overzichtelijk en kijk wat voor jou prettig werkt.",
    "lines": "Bij je wens rond fijne lijntjes of rimpels is dagelijkse zonbescherming een zinvolle basis.",
    "tone": "Bij je wens rond pigmentvlekjes of een ongelijkmatige teint is dagelijkse zonbescherming een zinvolle basis.",
    "firmness": "Je wilt aandacht geven aan stevigheid of elasticiteit. Dat nemen we mee als we samen naar passende verzorging kijken.",
    "barrier": "Je wilt dat je huid comfortabel aanvoelt en vocht goed kan vasthouden. Houd je verzorging rustig en kijk wat prettig voelt.",
    "simple": "Je wilt het eenvoudig houden. Een routine die prettig voelt en die je kunt volhouden is een goede basis."
  }
};
